import React, { useEffect, useState } from "react";
import Dashboard from "../../../layouts/Dashboard";
import { Card, Modal } from "antd";
import "../forms/Html/formsStyle.css";
import LoadingArea from "../../../components/LoadingArea";
import axios from "axios";
import BASE from "../../../config";
import ReactLoading from "react-loading";
import { DeleteOutlined, EyeOutlined, EditOutlined } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";
import { Table } from "antd";
import { message } from "antd";
import AddDocumentName from "../Components/AddDocumentName";
import { LOGOS } from "../../../utils/companyLogosObj";
import useAxios from "../../../hooks/useAxios";
import { formatDDMMYYYY } from "../forms/Html/LeagleDocuments/forms/commonfunctions";
import useRole from "../../../hooks/useRole";
import { checkPermission } from "../../../utils/checkPermission";
import { KOCHAR_LOGO, SIDE_BAR, KOCHAR_FOOTER, MAXICUS_LOGO, MAXICUS_FOOTER } from "../forms/logos";

const { Option } = Select;

const ASSETS_CONF = {
  kochar: {
    logo: KOCHAR_LOGO,
    sidebar: SIDE_BAR,
    footer: KOCHAR_FOOTER
  },
  maxicus: {
    logo: MAXICUS_LOGO,
    sidebar: '',
    footer: MAXICUS_FOOTER
  }
}

const COMPANY_NAMES = {
  All: "Kochar Infotech Ltd.",
  all: "Kochar Infotech Ltd.",
  kochar: "Kochar Infotech Ltd.",
  maxicus: "Maxicus Technologies Pvt. Ltd.",
  igzy: "Igzy Technologies Pvt. Ltd.",
  kochiva: "Kochiva Pvt. Ltd.",
  kocharsoft: "Kochar Innovation Pvt. Ltd.",
};

const PDF_LOGOS = {
  kochar: KOCHAR_LOGO,
  maxicus: MAXICUS_LOGO,
  igzy: "https://maxicus.com/mailer/igzy_hiring.png",
  kochiva: "https://maxicus.com/mailer/kochiva_hiring.png",
  kocharsoft: "https://maxicus.com/mailer/kocharsoft_hiring.png",
};

const getCompanyKey = (companyName = "") => {
  const value = String(companyName || "").toLowerCase();

  if (value.includes("kochiva")) return "kochiva";
  if (value.includes("kocharsoft") || value.includes("kochar innovation")) return "kocharsoft";
  if (value.includes("igzy")) return "igzy";
  if (value.includes("maxicus")) return "maxicus";
  if (value.includes("kochar") || value === "all") return "kochar";

  return value;
};

const getCompanyLogo = (companyKey) => {
  const logo = PDF_LOGOS[companyKey] || ASSETS_CONF[companyKey]?.logo || LOGOS[companyKey] || LOGOS.All;

  if (!logo || logo.startsWith("data:") || logo.startsWith("http")) {
    return logo;
  }

  return typeof window !== "undefined" ? `${window.location.origin}${logo}` : logo;
};

const getCompanyTitleElement = (htmlElement) => {
  const companyTitle = htmlElement.getElementById("company_name");

  if (companyTitle) {
    return companyTitle;
  }

  const isCompanyElement = (element) => {
    const text = element.textContent?.toLowerCase() || "";

    return (
      text.includes("maxicus") ||
      text.includes("kochar") ||
      text.includes("kochiva") ||
      text.includes("igzy")
    );
  };

  const headingTitle = Array.from(
    htmlElement.querySelectorAll("h1, h2, span")
  ).find(isCompanyElement);

  if (headingTitle) {
    return headingTitle;
  }

  const titleCell = Array.from(htmlElement.querySelectorAll("td")).find(
    isCompanyElement
  );

  return titleCell?.querySelector("h1, h2, span") || titleCell;
};

function CreateDoc() {
  const api = useAxios();
  const domParser = new DOMParser();
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [disable, setDisable] = useState(true);
  const [disableEdit, setDisableEdit] = useState(true);
  const [formHtml, setFormHtml] = useState("");
  const [url, setUrl] = useState("");
  const [businessType, setBusinessType] = useState("All");
  const [formType, setFormType] = useState("All");
  const [content, setContent] = useState("");
  const [trfType, setTrfType] = useState("");
  const [formName, setFormName] = useState("");
  const [docNumber, setDocNumber] = useState("");
  const [revNumber, setRevNumber] = useState("");
  const [wef, setWef] = useState("");
  const [addOns, setAddOns] = useState("");
  const [process, setProcess] = useState([]);
  const [forms, setForms] = useState([]);
  const [processId, setProcessId] = useState("");
  const [documentNames, setDocumentNames] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [documentName, setDocumentName] = useState("");
  const [openDocumentname, setOpenDocumentname] = useState(false);
  const [editFormData, setEditFormData] = useState({
    formData: "",
    _id: "",
    businessType: "",
    formType: "",
    processId: "",
    formName: "",
    wef: "",
    revNo: "",
    docNo: "",
    isOldCandidate: false,
    mendatory: false,
    addOns: "",
  });
  const [mendatory, setMendatory] = useState(true);
  const [isOldCandidate, setIsOldCandidate] = useState(false);
  const userRole = useRole();
  const [canViewCreateDoc, setCanViewCreateDoc] = useState(false);
  const [canCreateDoc, setCanCreateDoc] = useState(false);
  const [canEditDoc, setCanEditDoc] = useState(false);
  const [canDeleteDoc, setCanDeleteDoc] = useState(false);
  const [canViewDocument, setCanViewDocument] = useState(false);

  const checkPermissions = async () => {
    try {
      const [view, create, edit, del, viewDoc] = await Promise.all([
        checkPermission(userRole, "create_document_module", "view"),
        checkPermission(userRole, "create_document_module", "create"),
        checkPermission(userRole, "create_document_module", "edit"),
        checkPermission(userRole, "create_document_module", "delete"),
        checkPermission(userRole, "create_document_module", "view_document"),
      ]);
      setCanViewCreateDoc(view);
      setCanCreateDoc(create);
      setCanEditDoc(edit);
      setCanDeleteDoc(del);
      setCanViewDocument(viewDoc);
    } catch (error) {
      console.error("Permission check failed for Digital Document module:", error);
    }
  };

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  const getFormPreviewData = async (
    e,
    id,
    _html,
    companyName,
    formName,
    formType,
    data
  ) => {
    const htmlElement = domParser.parseFromString(_html, "text/html");
    let url = "";
    let _data = {};
    if (formType === "Joining" || formType === "Checklist") {
      const parentTable = htmlElement.querySelector(".parent");
      const foot_img = htmlElement.querySelector("#foot_img");
      if (foot_img) {
        const table = foot_img.querySelector("table");
        if (table) {
          foot_img.removeChild(table);
        }
      }

      const wef = data?.WEF
        ? `W.E.F : ${formatDDMMYYYY(new Date(data?.WEF))}`
        : htmlElement.getElementById("wef")?.innerText;
      const docNumber = data?.docNo
        ? `DOC NO : ${data?.docNo}`
        : htmlElement.getElementById("doc_number")?.innerText;
      const revisionNumber = data?.revNo
        ? `REV. NO : ${data?.revNo}`
        : htmlElement.getElementById("rev_number")?.innerText;
      const docName = data?.companyDocumentNamesId?.documentName || formName;

      const rows = Array.from(parentTable.childNodes[1].children);
      const newRows = Array.from(parentTable.childNodes[1].children).slice(1);

      rows.forEach((row) => {
        row.parentNode.removeChild(row);
      });
      newRows.forEach((row) => {
        parentTable.childNodes[1].appendChild(row);
      });

      url = `/companyDocuments/htmltoPdfTemplate`;
      _data = {
        wef,
        formName: docName,
        docNumber,
        companyName,
        revisionNumber,
        html: `<div id="container" class="formContainer"> 
              ${htmlElement.getElementById("container").innerHTML}
              </div>`,
      };
    } else if (formType === "Legal") {
      url = `/companyDocuments/htmltoPdfLegalFormTemplate`;
      _data = {
        html: `<div id="container" class="leagle"> 
  ${htmlElement.getElementById("container").innerHTML}
  </div>`,
      };
    }
    else if (formType === "Consent") {
      const companyKey = getCompanyKey(companyName);
      const logo = htmlElement.getElementById("logo");
      const companyTitle = getCompanyTitleElement(htmlElement);

      if (logo) {
        logo.src = getCompanyLogo(companyKey);
      }

      if (companyTitle) {
        companyTitle.innerText = COMPANY_NAMES[companyKey] || companyName;
      }

      url = `/companyDocuments/htmltoPdfLegalFormTemplate`;
      _data = {
        html: `<div id="container">
      ${htmlElement.getElementById("container").innerHTML}
    </div>`,
      };
    }
    else {
      const logo = htmlElement.querySelectorAll(".logo");
      const _companyName = companyName?.toLowerCase();

      if (logo && ASSETS_CONF[_companyName]) {
        for (let i = 0; i < logo.length; i++) {
          logo[i].src = ASSETS_CONF[_companyName].logo;
        }
      }

      const sidebar = htmlElement.querySelectorAll(".sidebar");
      if (sidebar && ASSETS_CONF[_companyName]) {
        for (let i = 0; i < sidebar.length; i++) {
          sidebar[i].src = ASSETS_CONF[_companyName].sidebar;
        }
      }

      const footer = htmlElement.querySelectorAll(".footer");
      if (footer && ASSETS_CONF[_companyName]) {
        for (let i = 0; i < footer.length; i++) {
          footer[i].src = ASSETS_CONF[_companyName].footer;
        }
      }

      url = `/companyDocuments/htmltoPdfOfferLetterFormTemplate`;
      _data = {
        html: `<div id="container"> 
  ${htmlElement.getElementById("container").innerHTML}
  </div>`,
      };
    }

    try {
      setOpen(true);
      setLoading(true);
      const result = await api.post(url, _data, {
        tokenType: "user",
      });
      const uint8Array = new Uint8Array(result.data.data);
      const blob = new Blob([uint8Array], { type: "application/pdf" });
      const _url = URL.createObjectURL(blob);
      setUrl(_url);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }

    // setOpen(true);
    // setLoading(true);
    // const config = {
    // url: BASE.api + `/companyDocuments/${id}`,
    // method: "get",
    // headers: {
    // "Content-Type": "application/json",
    // Authorization: `Bearer ${localStorage.getItem("user.token")}`
    // }
    // };

    // try {
    // const form = await axios(config);
    // if (form.data.companyDocument[0].status) {
    // setFormHtml(form.data.companyDocument[0].formData);
    // setTrfType(form.data.companyDocument[0].businessType);
    // setLoading(false);
    // }
    // } catch (err) {
    // console.log(err);
    // setLoading(false);
    // }
  };

  const deleteFormData = async (e, id) => {
    setLoading(true);
    try {
      const form = await api.delete(`/companyDocuments/${id}`, {
        tokenType: "user",
      });
      console.log(form.data);
      getAllForms();
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const [error, setError] = useState({});

  useEffect(() => {
    let e = {};
    if (docNumber && !/^[a-zA-Z0-9/]+$/.test(docNumber)) {
      e.docNumber = "Special character not allowed.";
    } else {
      delete e.docNumber;
    }

    setError(e);
  }, [docNumber]);

  const onClickSubmitContent = async (e) => {
    e.preventDefault();

    if (Object.keys(error).length !== 0) return;

    setLoad(true);
    try {
      const response = await api.post(
        `/companyDocuments`,
        {
          formName: formName?.trim(),
          formData: content,
          businessType: businessType,
          formType: formType,
          docNo: mendatory ? docNumber : "",
          revNo: mendatory ? revNumber : "",
          WEF: mendatory ? wef : "",
          addOns: addOns,
          processId: processId || null,
          isOldCandidate: isOldCandidate,
        },
        { tokenType: "user" }
      );
      if (response.data.status) {
        setContent("");
        setFormName("");
        setBusinessType("");
        setFormType("All");
        setRevNumber("");
        setDocNumber("");
        setWef("");
        setProcessId("");
        setAddOns("");
        getAllForms();
      }
    } catch (err) {
      console.log(err);
      message.error(err.response.data.message.Message, 2);
      setLoad(false);
    }
  };

  const getProcessList = async () => {
    try {
      const res = await api.get(`/processes`, { tokenType: "user" });
      setProcess(res.data.processes);
    } catch (err) {
      console.log(err);
      setProcess([]);
    }
  };

  const getBusinessTypeList = async () => {
    try {
      const response = await api.get(`/samparkDomain`, { tokenType: "user" });
      console.log(response);
      setBusinessTypeList(response.data.samparkDomainList);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const getFormUpdate = async () => {
    setLoading(true);
    try {
      const forms = await api.post(
        `/companyDocuments`,
        {
          formName: editFormData.formName?.trim(),
          formData: editFormData.formData,
          businessType: editFormData.businessType,
          formType: editFormData.formType,
          docNo: mendatory ? editFormData?.docNo : "",
          revNo: mendatory ? editFormData?.revNo : "",
          WEF: mendatory ? editFormData?.wef : "",
          addOns: editFormData?.addOns,
          processId: editFormData?.processId || null,
          isOldCandidate: editFormData?.isOldCandidate,
        },
        { tokenType: "user" }
      );
      console.log(forms);
      await getAllForms();
      setLoading(false);
      setOpenEdit(false);
      message.success("Document Updated Successfully", 2);
    } catch (err) {
      console.log(err);
      message.error(err.response.data.message.Message, 2);
      setLoading(false);
    }
  };

  const getAllFormNames = async (e) => {
    try {
      const res = await api.get(`/companyDocumentNames`, { tokenType: "user" });
      console.log(res, "abhi");
      setDocumentNames(res.data.companyDocumentNames);
    } catch (err) {
      console.log(err);
      setDocumentNames([]);
    }
  };

  const getAllForms = async () => {
    setLoad(true);
    try {
      const forms = await api.get(`/companyDocuments`, { tokenType: "user" });

      let data = [];
      for (let i = 0; i < forms.data?.length; i++) {
        let formName = forms.data[i]?.formName;

        data.push({
          sno: i + 1,
          name: formName,
          businessType: forms.data[i]?.businessType,
          formType: forms.data[i]?.formType,
          process: forms.data[i]?.processId
            ? forms.data[i]?.processId?.name
            : "All",
           action: forms.data[i],
          // action: (
          //   <div
          //     className="d-flex align-items-center justify-content-center"
          //     style={{ gap: "1rem" }}
          //   >
          //     <EyeOutlined
          //       style={{ fontSize: "20px", color: "green" }}
          //       onClick={(e) =>
          //         getFormPreviewData(
          //           e,
          //           forms.data[i]._id,
          //           forms.data[i]?.formData,
          //           forms.data[i]?.businessType,
          //           forms.data[i]?.formName,
          //           forms.data[i]?.formType,
          //           forms.data[i]
          //         )
          //       }
          //     />
          //     <EditOutlined
          //       style={{ fontSize: "20px", color: "#08c" }}
          //       onClick={(e) => {
          //         setEditFormData({
          //           ...editFormData,
          //           _id: forms.data[i]._id,
          //           formData: forms.data[i]?.formData,
          //           businessType: forms.data[i]?.businessType,
          //           formType: forms.data[i]?.formType,
          //           formName: forms.data[i]?.formName,
          //           processId: forms.data[i]?.processId?._id,
          //           wef: forms.data[i]?.WEF,
          //           revNo: forms.data[i]?.revNo,
          //           docNo: forms.data[i]?.docNo,
          //           isOldCandidate: forms.data[i]?.isOldCandidate,
          //           addOns: forms.data[i]?.addOns,
          //           mendatory:
          //             forms.data[i]?.WEF &&
          //               forms.data[i]?.WEF &&
          //               forms.data[i]?.WEF
          //               ? true
          //               : false,
          //         });
          //         setOpenEdit(true);
          //       }}
          //     />
          //     <DeleteOutlined
          //       style={{ fontSize: "20px", color: "red" }}
          //       onClick={(e) => deleteFormData(e, forms.data[i]._id)}
          //     />
          //   </div>
          // ),
        });
      }
      setTableData([...data]);
      setForms([...forms.data]);
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  useEffect(() => {
    getAllForms();
    getBusinessTypeList();
    // getAllFormNames();
    getProcessList();
  }, []);

  useEffect(() => {
    if (
      formName.trim() &&
      content.trim() &&
      businessType.trim() &&
      formType.trim() &&
      addOns.trim() !== ""
    ) {
      if (mendatory) {
        if (docNumber.trim() && revNumber.trim() && wef !== "") {
          setDisable(false);
        } else {
          setDisable(true);
        }
        return;
      }
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [
    formName,
    content,
    businessType,
    formType,
    docNumber,
    wef,
    revNumber,
    addOns,
    mendatory,
  ]);

  useEffect(() => {
    if (
      editFormData.formName?.trim() &&
      editFormData.formData?.trim() &&
      editFormData.businessType?.trim() &&
      editFormData.formType?.trim()
    ) {
      setDisableEdit(false);
    } else {
      setDisableEdit(true);
    }

    if (
      editFormData.formName?.trim() &&
      editFormData.formData?.trim() &&
      editFormData.businessType?.trim() &&
      editFormData.formType?.trim() &&
      editFormData.addOns?.trim() !== ""
    ) {
      if (editFormData?.mendatory) {
        if (
          editFormData?.docNo.trim() &&
          editFormData?.revNo.trim() &&
          editFormData?.wef !== ""
        ) {
          setDisableEdit(false);
        } else {
          setDisableEdit(true);
        }
        return;
      }
      setDisableEdit(false);
    } else {
      setDisableEdit(true);
    }
  }, [editFormData]);

  useEffect(() => {
    const htmlElement = domParser.parseFromString(formHtml, "text/html");
    const preview = document.getElementById("preview");
    if (preview && formHtml) {
      const companyKey = getCompanyKey(trfType);
      if (htmlElement.getElementById("logo") !== null) {
        htmlElement.getElementById("logo").src = getCompanyLogo(companyKey);
      }
      const companyTitle = getCompanyTitleElement(htmlElement);
      if (companyTitle !== null) {
        companyTitle.innerText = COMPANY_NAMES[companyKey] || trfType;
      }
      preview.appendChild(htmlElement.getElementById("container"));
    }
  }, [loading, formHtml]);

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name > b.name,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Business",
      dataIndex: "businessType",
      key: "businessType",
      sorter: (a, b) => a.businessType > b.businessType,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.businessType.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Process",
      dataIndex: "process",
      key: "process",
      sorter: (a, b) => a.process > b.process,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.process.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Form Type",
      dataIndex: "formType",
      key: "formType",
      sorter: (a, b) => a.formType > b.formType,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.formType.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      align: "center",
      render: (data) => {
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "1rem" }}
          >
            {canViewDocument && (
              <EyeOutlined
                style={{ fontSize: "20px", color: "green" }}
                onClick={(e) =>
                  getFormPreviewData(
                    e,
                    data._id,
                    data?.formData,
                    data?.businessType,
                    data?.formName,
                    data?.formType,
                    data
                  )
                }
              />
            )}
            {canEditDoc && (
              <EditOutlined
                style={{ fontSize: "20px", color: "#08c" }}
                onClick={(e) => {
                  setEditFormData({
                    ...editFormData,
                    _id: data._id,
                    formData: data?.formData,
                    businessType: data?.businessType,
                    formType: data?.formType,
                    formName: data?.formName,
                    processId: data?.processId?._id,
                    wef: data?.WEF,
                    revNo: data?.revNo,
                    docNo: data?.docNo,
                    isOldCandidate: data?.isOldCandidate,
                    addOns: data?.addOns,
                    mendatory: data?.WEF && data?.WEF && data?.WEF ? true : false,
                  });
                  setOpenEdit(true);
                }}
              />
            )}
            {canDeleteDoc && (
              <DeleteOutlined
                style={{ fontSize: "20px", color: "red" }}
                onClick={(e) => deleteFormData(e, data._id)}
              />
            )}
          </div>
        );
      },
    },
  ];

  if (!canViewCreateDoc) {
    return <div></div>;
  }

  return (
    <Dashboard title="Digital Document">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row">
        <div className="col-md-6">
          <Card
            title={
              <div className="row">
                <div className="col-10">Create Form Name</div>
                {/* <div className="col-md-2 px-1">
                  <button
                    style={{ width: "50px" }}
                    onClick={() => setOpenDocumentname(!openDocumentname)}
                    className="btn btn-primary btn-sm btn-block"
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                  </button>
                  <AddDocumentName
                    setDocumentName={setDocumentName}
                    documentName={documentName}
                    openDocumentname={openDocumentname}
                    setOpenDocumentname={setOpenDocumentname}
                    setLoad={setLoad}
                    getAllFormNames={getAllFormNames}
                  />
                </div> */}
              </div>
            }
            className="border mt-1"
          >
            <div>
              <label htmlFor="">
                Select Business Type<span style={{ color: "red" }}>*</span>
              </label>
              <Select
                id="busineesType"
                showSearch
                value={businessType}
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Business Type"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value) => setBusinessType(value)}
              >
                <Option value={"All"}>All</Option>
                {businessTypeList?.map((business) => (
                  <Option value={business?.businessType}>
                    {business?.businessType}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="mt-2">
              <label htmlFor="">
                Select Process<span style={{ color: "red" }}>*</span>
              </label>
              <Select
                showSearch
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Location"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                value={processId}
                onChange={(value) => setProcessId(value)}
              >
                <Option value={"All"}>All</Option>
                {process?.map(
                  (opt) =>
                    opt?.name && <Option value={opt?._id}>{opt?.name}</Option>
                )}
              </Select>
            </div>
            <div className="mt-2">
              <label htmlFor="">
                Select Form Type<span style={{ color: "red" }}>*</span>
              </label>
              <Select
                id="formType"
                showSearch
                value={formType}
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Form Type"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value) => setFormType(value)}
              >
                <Option value={"All"}>All</Option>
                <Option value={"Joining"}>Joining Document</Option>
                <Option value={"Legal"}>Legal Document</Option>
                <Option value={"Checklist"}>Checklist Document</Option>
                <Option value={"Consent"}>Consent</Option>
                <Option value={"OfferLetter-NAP-NATS"}>
                  Offer Letter NAP NATS
                </Option>
                <Option value={"OfferLetter-GIG"}>Offer Letter GIG</Option>
              </Select>
            </div>
            {/* <div className="mt-2">
              <label htmlFor="">Select Form Name</label>
              <Select
                id="formName"
                showSearch
                value={formName}
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Form Type"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value) => setFormName(value)}
              >
                {documentNames?.map((doc) => (
                  <Option value={doc?._id}>{doc?.documentName}</Option>
                ))}
              </Select>
            </div> */}
            <div className="custom-control custom-radio mt-2">
              <input
                id="mendatory"
                name="sex"
                type="checkbox"
                className="custom-control-input form-view"
                onChange={(e) => setMendatory(!mendatory)}
                checked={mendatory}
              />
              <label htmlFor="mendatory" className="custom-control-label">
                Is document details required
              </label>
            </div>

            {mendatory && (
              <>
                <div className="mt-2">
                  <label htmlFor="">
                    Enter WEF<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="date"
                    className="border form-control"
                    placeholder="Enter WEF"
                    // min={formatDate(new Date())}
                    onChange={(e) => setWef(e.target.value)}
                    value={wef}
                  />
                </div>
                <div className="mt-2">
                  <label htmlFor="">
                    Enter Document Number<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="border form-control"
                    placeholder=""
                    onChange={(e) => setDocNumber(String(e.target.value))}
                    value={docNumber}
                    styl
                  />
                  {error?.docNumber && (
                    <p style={{ color: "red" }}>{error.docNumber}</p>
                  )}
                </div>
                <div className="mt-2">
                  <label htmlFor="">
                    Enter Revision Number<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="border form-control"
                    placeholder=""
                    onChange={(e) => setRevNumber(String(e.target.value))}
                    min={0.0}
                    value={revNumber}
                  />
                </div>
              </>
            )}
            <div className="mt-2">
              <label htmlFor="">
                Enter Document Name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="border form-control"
                placeholder=""
                onChange={(e) => setFormName(e.target.value)}
                value={formName}
              />
            </div>
            <div className="mt-2">
              <label htmlFor="">
                Enter Your Html Code<span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                placeholder="Paste Your HTML Code"
                className="border doc_container form-control"
                onChange={(e) => setContent(e.target.value)}
                value={content}
              ></textarea>
            </div>
            <div className="mt-2">
              <label htmlFor="">
                Enter Description<span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                style={{ height: "50px" }}
                placeholder="Enter Description"
                className="border form-control"
                onChange={(e) => setAddOns(e.target.value)}
                value={addOns}
              ></textarea>
            </div>
            {/* <div className="custom-control custom-radio mt-2">
              <input
                id="is_old"
                name="sex"
                type="checkbox"
                className="custom-control-input form-view"
                onChange={(e) => setIsOldCandidate(!isOldCandidate)}
                checked={isOldCandidate}
              />
              <label htmlFor="is_old" className="custom-control-label">
                Is old candidate
              </label>
            </div> */}
            <div className="text-center">
              <button
                className={`btn mt-4 ${!disable ? "btn-primary" : "btn-secondary"
                  }`}
                type="submit"
                onClick={onClickSubmitContent}
                disabled={disable}
              >
                Submit
              </button>
            </div>
          </Card>
        </div>
        <div className="col-md-6">
          <Card title="Form List" className="border mt-1">
            <div style={{ width: "100%" }}>
              <Table
                columns={columns}
                dataSource={tableData}
                pagination={{
                  total: 0,
                  pageSizeOptions: ["5", "10", "30", "60", "100"],
                  showSizeChanger: true,
                }}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre" }}
                exportFileName="details"
              />
            </div>
          </Card>
        </div>
        <Modal
          centered
          open={open}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          width={1000}
          title="Company Document"
        >
          <LoadingArea isLoading={loading}>
            {/* <div id="preview"></div> */}
            <div>
              <iframe
                style={{ width: "100%" }}
                title="iframe"
                className="iframe"
                width="100%"
                height="600"
                src={url}
              >
                <p>iframes are not supported by your browser.</p>
              </iframe>
            </div>
          </LoadingArea>
        </Modal>
        <Modal
          centered
          open={openEdit}
          onOk={() => setOpenEdit(false)}
          onCancel={() => setOpenEdit(false)}
          footer={false}
          width={1000}
        >
          <LoadingArea isLoading={loading}>
            <div>
              <div className="col-md-12">
                <Card title="Update Form" className="border mt-3">
                  <div>
                    <label htmlFor="">
                      Select Business Type
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      id="city"
                      showSearch
                      value={editFormData.businessType}
                      style={{ width: "100%", height: "37px" }}
                      placeholder="Select Business Type"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        return (
                          option?.children
                            ?.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0 ||
                          option.value
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }}
                      onChange={(value) =>
                        setEditFormData({
                          ...editFormData,
                          businessType: value,
                        })
                      }
                    >
                      {businessTypeList?.map((business) => (
                        <Option value={business?.businessType}>
                          {business?.businessType}
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div className="mt-2">
                    <label htmlFor="">
                      Select Process<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      showSearch
                      style={{ width: "100%", height: "37px" }}
                      placeholder="Select Location"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        return (
                          option?.children
                            ?.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0 ||
                          option.value
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }}
                      value={editFormData?.processId || ""}
                      onChange={(value) =>
                        setEditFormData({
                          ...editFormData,
                          processId: value,
                        })
                      }
                    >
                      <Option value={""}>All</Option>
                      {process?.map(
                        (opt) =>
                          opt?.name && (
                            <Option value={opt?._id}>{opt?.name}</Option>
                          )
                      )}
                    </Select>
                  </div>
                  <div className="mt-2">
                    <label htmlFor="">
                      Select Form Type<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      id="city"
                      showSearch
                      value={editFormData?.formType}
                      style={{ width: "100%", height: "37px" }}
                      placeholder="Select Business Type"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        return (
                          option?.children
                            ?.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0 ||
                          option.value
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }}
                      onChange={(value) =>
                        setEditFormData({
                          ...editFormData,
                          formType: value,
                        })
                      }
                    >
                      <Option value={"All"}>All</Option>
                      <Option value={"Joining"}>Joining Document</Option>
                      <Option value={"Legal"}>Legal Document</Option>
                      <Option value={"Checklist"}>Checklist Document</Option>
                      <Option value={"Consent"}>Consent</Option>
                      <Option value={"OfferLetter-NAP-NATS"}>
                        Offer Letter NAP NATS
                      </Option>
                      <Option value={"OfferLetter-GIG"}>
                        Offer Letter GIG
                      </Option>
                    </Select>
                  </div>
                  {/* {editFormData?.companyDocumentNamesId ? (
                    <>
                      <div className="mt-2">
                        <label htmlFor="">Select Form Name</label>
                        <Select
                          id="formName"
                          showSearch
                          value={editFormData?.companyDocumentNamesId}
                          style={{ width: "100%", height: "37px" }}
                          placeholder="Select Form Type"
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) =>
                            setEditFormData({
                              ...editFormData,
                              companyDocumentNamesId: value,
                            })
                          }
                        >
                          {documentNames?.map((doc) => (
                            <Option value={doc?._id}>
                              {doc?.documentName}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </>
                  ) : (
                    <> */}
                  <div className="mt-2">
                    <label htmlFor="">
                      Enter Document Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="border form-control"
                      placeholder=""
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          formName: e.target.value,
                        })
                      }
                      value={editFormData?.formName}
                    />
                  </div>
                  {/* </>
                  )} */}

                  <div className="custom-control custom-radio mt-2">
                    <input
                      id="mendatory_edit"
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          mendatory: !editFormData?.mendatory,
                        })
                      }
                      checked={editFormData?.mendatory}
                    />
                    <label
                      htmlFor="mendatory_edit"
                      className="custom-control-label"
                    >
                      Is document details required
                    </label>
                  </div>

                  {editFormData?.mendatory && (
                    <>
                      <div className="mt-2">
                        <label htmlFor="">
                          Enter WEF<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className="border form-control"
                          placeholder="Enter WEF"
                          // min={formatDate(new Date())}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              wef: e.target.value,
                            })
                          }
                          value={editFormData?.wef}
                        />
                      </div>
                      <div className="mt-2">
                        <label htmlFor="">
                          Enter Document Number
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <input
                          type="text"
                          className="border form-control"
                          placeholder=""
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              docNo: e.target.value,
                            })
                          }
                          value={editFormData?.docNo}
                          styl
                        />
                        {error?.docNumber && (
                          <p style={{ color: "red" }}>{error.docNumber}</p>
                        )}
                      </div>
                      <div className="mt-2">
                        <label htmlFor="">
                          Enter Revision Number
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <input
                          type="number"
                          className="border form-control"
                          placeholder=""
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              revNo: e.target.value,
                            })
                          }
                          min={0.0}
                          value={editFormData?.revNo}
                        />
                      </div>
                    </>
                  )}
                  <div className="mt-2">
                    <label htmlFor="">
                      Enter Your Html Code
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      placeholder="Paste Your HTML Code"
                      className="border doc_container form-control"
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          formData: e.target.value,
                        })
                      }
                      value={editFormData.formData}
                    ></textarea>
                  </div>
                  <div className="mt-2">
                    <label htmlFor="">
                      Enter Description<span style={{ color: "red" }}>*</span>
                    </label>

                    <textarea
                      style={{ height: "50px" }}
                      placeholder="Enter Description"
                      className="border form-control"
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          addOns: e.target.value,
                        })
                      }
                      value={editFormData?.addOns}
                    ></textarea>
                  </div>
                  {/* <div className="custom-control custom-radio mt-2">
                    <input
                      id="is_old_edit"
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          isOldCandidate: !editFormData?.isOldCandidate,
                        })
                      }
                      checked={editFormData?.isOldCandidate}
                    />
                    <label
                      htmlFor="is_old_edit"
                      className="custom-control-label"
                    >
                      Is old candidate
                    </label>
                  </div> */}
                  <div className="text-center">
                    <button
                      className={`btn mt-4 ${!disableEdit ? "btn-primary" : "btn-secondary"
                        }`}
                      type="submit"
                      onClick={getFormUpdate}
                      disabled={disableEdit}
                    >
                      Create New Revision
                    </button>
                  </div>
                </Card>
              </div>
            </div>
          </LoadingArea>
        </Modal>
      </div>
    </Dashboard>
  );
}

export default CreateDoc;
